export function makeIsNotEqualNumber<T>(num: number, errorMsg: T) {
  return (value?: string | number) => {
    const validatingValue = Number(value);

    if (validatingValue === num) {
      return errorMsg;
    }

    return undefined;
  };
}
